import { View } from "@/components/ui";
import { Link } from "@/components/shared/link";
// import { ArrowLeft } from "@/components/shared/icons";
import { AddressListContainer } from "../../address-list";
import { Typography } from "@/components/shared/typography";
import { IconButton } from "@/components/ui/icon-button/index.web";
import { useRoute } from "@/components/shared/router";
import { useWindowDimensions } from "@/components/hooks/use-window-dimension";

export const AddressesPage = () => {
  const { push } = useRoute();
  const { isMobile } = useWindowDimensions();
  return (
    <View>
      <View className="static mb-4 flex flex-row items-start justify-between border-b md:mb-8 md:pb-4">
        <View className="flex flex-row items-center gap-2 p-4 md:p-0">
          {/* CONSISTENECY PROBLEM <Link href="/profile/account-info">
            <ArrowLeft className="visible size-5" />
          </Link> */}
          <IconButton
            variant={isMobile ? "ghost" : "secondary"}
            color="foreground"
            iconName="arrowLeft"
            rounded="full"
            className="p-0 md:px-3 md:py-2"
            onClick={() => push({ pageKey: "accountInfo" })}
          />
          <Typography variant="label-md">Address</Typography>
        </View>
        <View className="fixed bottom-0 z-50 w-full bg-white px-4 py-6 text-sm md:static md:w-auto md:p-0">
          <View className="native:hidden flex justify-center rounded-full bg-secondary-button px-4 py-2 text-white">
            {/* our old app limit the address only 3, we perhaps enhance the disable condition when get confirmation of the address limit */}
            <Link href="/profile/addresses/new">
              <Typography color="white" variant="label-lg">
                Add new Address
              </Typography>
            </Link>
          </View>
        </View>
      </View>

      <AddressListContainer />
    </View>
  );
};
